import React from 'react';
import { Button, Col, Row, Affix } from 'antd';

class LicenseAgreement extends React.Component {
  render() {
    return (
      <React.Fragment>
        <div id="addLicensee" className="basicForm">
          <Row type="flex" justify="space-between" gutter={16}>
            <Col span={18}>
              <div className="formContainer">
                <div style={{ textAlign: 'center', marginBottom: 20 }}>
                  <span style={{ fontSize: 16, fontWeight: 'bold' }}>
                    Лицензионное соглашение
                    <br />
                    на использование базы данных «TELEPORTOS» и прикладной
                    программы «TELEPORTOS»
                  </span>
                </div>
                <div>
                  <p>
                    Перед использованием базы данных «TELEPORTOS» и прикладной
                    программы «TELEPORTOS», пожалуйста, ознакомьтесь с условиями
                    нижеследующего лицензионного соглашения.
                  </p>
                  <p>
                    <b>I. Термины</b>
                  </p>
                  <p>
                    &nbsp; &nbsp; 1. Лицензия — настоящее лицензионное
                    соглашение между правообладателем и пользователем,
                    содержащее
                  </p>
                  <p>
                    все необходимые и существенные условия лицензионного
                    договора о предоставлении прав использования базы данных
                  </p>
                  <p>
                    и программы, заключаемое путём размещения публичной оферты,
                    и заключаемое не иначе как путём присоединения
                  </p>
                  <p>к предложенному договору в целом (ст. 428 ГК РФ).</p>
                  <p>
                    &nbsp; &nbsp; 2. База данных — совокупность заявок и
                    заказов, систематизированных таким образом, что эти заявки
                  </p>
                  <p>
                    и заказы могут быть найдены и обработаны с помощью ЭВМ.
                    Исключительное право на базу данных принадлежит
                    правообладателю.
                  </p>
                  <p>
                    &nbsp; 3. Программа — совокупность данных и команд,
                    предназначенных для функционирования ЭВМ и других
                    компьютерных устройств, предоставляющую функциональную
                    возможность использовать базу данных на условиях, описанных
                    в настоящей лицензии. Лицензия предоставляется на право
                    использования web-приложения пользователя и мобильного
                    приложения водителя. Доступ к программе осуществляется по
                    учётной записи пользователя, обеспечивающей доступ к
                    определённому функционалу программ и базы данных, сайта
                    teleportos.ru. Исключительное право на программу принадлежит
                    правообладателю.
                  </p>
                  <p>
                    &nbsp; &nbsp;4. Заказы — размещённые в базе данных сведения
                    о реализуемых пользователем транспортных услугах по
                    заключённым на основании принятых ими заявок договорам,
                    включающие данные о транспортном средстве, контактных данных
                  </p>
                  <p>сторон и др.</p>
                  <p>
                    &nbsp; &nbsp; 5. Заявки — размещаемые в базе данных заявок
                    сведения о предложениях заказчиков транспортных услуг,
                    которые могут быть использованы исполнителями транспортных
                    услуг для формирования своих заказов и заключения
                    соответствующих договоров.
                  </p>
                  <p>
                    &nbsp; &nbsp; 6. Пользователь — юридическое или физическое
                    лицо, использующее базу данных и программу
                  </p>
                  <p>для оказания транспортных услуг.</p>
                  <p>
                    &nbsp; &nbsp; 7. Правообладатель — ООО «Сирена Бас»,
                    являющееся обладателем исключительного права на базу данных
                    и программу.
                  </p>
                  <p>
                    &nbsp; &nbsp; 8. Учётная запись — уникальный идентификатор
                    пользователя, который используется для учёта информации
                  </p>
                  <p>
                    о лицензионном вознаграж­де­нии. Учётная запись создаётся
                    автоматически при первом внесении денежных средств
                    &nbsp;&nbsp;
                  </p>
                  <p>
                    пользователем на счёт правообладателя при условия
                    предварительной регистрации пользователя.
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <b>II. Предмет лицензии</b>
                  </p>
                  <p>
                    &nbsp; &nbsp;1. Правообладатель на условиях простой
                    (неисключительной) лицензии предоставляет пользователю право
                    использования базой данных путём обработки сведений о
                    заказах специально разработанной программой в целях
                    оформления
                  </p>
                  <p>
                    и исполнения заказов, мониторинга времени использования
                    транспортных средств и их местонахождения, оформления
                    документов и расчётов с заказчиками.
                  </p>
                  <p>
                    &nbsp; 2. Правообладатель, несущий финансовые, материальные,
                    организационные и иные затраты для создания базы данных,
                    является обладателем исключительного права изготовителя базы
                    данных (ст. 1334 ГК РФ).
                  </p>
                  <p>
                    &nbsp; &nbsp;3. Правообладатель на условиях простой
                    (неисключительной) лицензии предоставляет пользователю право
                    использования специально разработанной программы в целях
                    получения доступа к базе данных, а также в целях изменения
                    базы данных путём создания, редактирования заказов в базе
                    данных для их дельнейшей обработки.
                  </p>
                  <p>
                    &nbsp; &nbsp; 4. Выполнение доступа к базе данных возможно
                    только при наличии доступа к сети Интернет.
                  </p>
                  <p>
                    Пользователь самостоятельно получает и оплачивает такой
                    доступ на условиях и по тарифам своего оператора связи
                  </p>
                  <p>или провайдера доступа к сети Интернет.</p>
                  <p>
                    &nbsp; &nbsp; 5. Действие настоящей лицензии
                    распространяется на все последующие обновления/новые версии
                    программы.
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <b>III. Вступление лицензии в силу</b>
                  </p>
                  <p>
                    &nbsp; &nbsp; 1. Получая право использования базы данных или
                    используя программу любым образом, пользователь
                    выражает&nbsp;
                  </p>
                  <p>
                    своё полное и безоговорочное согласие со всеми условиями
                    лицензии.
                  </p>
                  <p>
                    &nbsp; &nbsp; 2. Настоящая лицензия может изменяться
                    правообладателем в одностороннем порядке. Уведомление
                    пользователя
                  </p>
                  <p>
                    о внесённых изменениях в условия настоящей лицензии
                    публикуется на сайте teleportos.ru. Указанные изменения в
                    условиях лицензии вступают в силу с даты их публикации, если
                    иное не оговорено в соответствующей публикации.
                  </p>
                  <p>
                    &nbsp; &nbsp; 3. Использование базы данных и программы
                    разрешается только на условиях настоящей лицензии. Если
                    пользователь
                  </p>
                  <p>
                    не принимает условия лицензии в полном объёме, пользователь
                    не имеет права использовать базу данных и программу
                  </p>
                  <p>
                    в каких-либо целях. Использование базы данных и программы с
                    нарушением (невыполнением) какого-либо из условий лицензии
                    запрещено.
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <b>IV. Пределы использования базы данных и программы</b>
                  </p>
                  <p>
                    &nbsp; &nbsp; 1. За исключением использования в объёмах и
                    способами, прямо предусмотренными настоящей лицензией
                  </p>
                  <p>
                    или законодательством РФ, пользователь не имеет права
                    изменять, декомпилировать, дизассемблировать, дешифровать
                  </p>
                  <p>
                    и производить иные действия с объектным кодом программы,
                    имеющие целью получение информации о реализации алгоритмов,
                    используемых в программе; создавать производные произведения
                    с использованием программы,
                  </p>
                  <p>
                    а также осуществлять (разрешать осуществлять) иное
                    использование программы, любых компонентов программы и
                    прочих данных, без письменного согласия правообладателя.
                  </p>
                  <p>
                    &nbsp; &nbsp; 2. Пользователь не имеет права воспроизводить
                    и распространять (в том числе в отличном от того, в котором
                  </p>
                  <p>
                    он её получил виде) базу данных и программу в коммерческих
                    целях (в том числе за плату) без письменного согласия
                    правообладателя.
                  </p>
                  <p>
                    &nbsp; &nbsp; 3. Пользователь не вправе изменять и/или
                    удалять наименование базы данных и программы, знак охраны
                    авторского права (copyright notice) или иные указания на
                    правообладателя.
                  </p>
                  <p>
                    &nbsp; &nbsp; 4. Правообладатель оставляет за собой право
                    устанавливать любые правила, лимиты и ограничения
                  </p>
                  <p>
                    (технические, юридические, организационные или иные) на
                    использование программы в целом и базы данных, и может
                    менять их по собственному усмотрению, без предварительного
                    уведомления пользователей. Указанные правила, лимиты
                  </p>
                  <p>
                    и ограничения могут быть различными для различных категорий
                    пользователей.
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <b>V. Права и обязанности правообладателя</b>
                  </p>
                  <p>
                    &nbsp; &nbsp; 1. Правообладатель обязуется предоставить
                    пользователю возможность использования базы данных и
                    программы
                  </p>
                  <p>в соответствии с условиями настоящей лицензии.</p>
                  <p>
                    &nbsp; &nbsp; 2. Правообладатель вправе вносить изменения в
                    прайс-лист, определяющий цену использования программы
                  </p>
                  <p>
                    и базы данных. Такое измене­ние не влечёт изменение
                    обязательств сторон в отношении оплаченного периода
                    использования.
                  </p>
                  <p>
                    &nbsp; &nbsp; 3. Правообладатель вправе прекратить или
                    ограничить доступ к базе данных и использование программы
                  </p>
                  <p>в следующих случаях:</p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; а) истечения оплаченного срока
                    использования базы данных и/или программы.
                  </p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; б) досрочного самостоятельного
                    прекращения пользователем использования базы данных и/или
                    программы
                  </p>
                  <p>&nbsp; &nbsp; &nbsp; &nbsp; по заявлению пользователя.</p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; в) нарушения пользователем
                    условий настоящей лицензии.
                  </p>
                  <p>
                    &nbsp; &nbsp; 4. Правообладатель вправе самостоятельно и без
                    уведомления пользователя удалить Объявления,
                  </p>
                  <p>размещённые пользователем в Базе данных в случае:&nbsp;</p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; а) если относительного таких
                    данных у правообладателя имеются или, по мнению
                    правообладателя, могут
                  </p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; появиться жалобы со стороны
                    третьих лиц или других Пользователей;
                  </p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; б) если размещение пользователем
                    таких заказов &nbsp; нарушает условия настоящей лицензии.
                  </p>
                  <p>
                    &nbsp; &nbsp; 5. Правообладатель имеет право направлять
                    пользователю информационные, в том числе рекламные,
                  </p>
                  <p>
                    сообщения посредством электронной почты, пуш-уведомлений и
                    смс-сообщений. Пользователь также в соответствии
                  </p>
                  <p>
                    с ч. 1 ст. 18 Федерального закона «О рекламе» даёт своё
                    согласие на получение сообщений рекламного
                  </p>
                  <p>
                    характера. Пользователь вправе отказаться от получения
                    сообщений рекламного характера путём использования
                    соответствующего функционала программы.
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <b>VI. Права и обязанности пользователя</b>
                  </p>
                  <p>
                    &nbsp; &nbsp;1. Пользователь обязуется в соответствии с
                    условиями настоящей лицензии, выплачивать правообладателю
                    лицензионное вознаграждение согласно прайс листу стоимости
                    лицензии.
                  </p>
                  <p>
                    &nbsp; &nbsp; 2. Пользователь обязуется не передавать
                    полученные по настоящей лицензии права использования базы
                    данных
                  </p>
                  <p>
                    и программы какому-либо третьему лицу без предварительного
                    письменного согласия правообладателя.
                  </p>
                  <p>
                    &nbsp; &nbsp; 3. Пользователь обязуется не вносить изменений
                    в базу данных с использованием объектов,
                  </p>
                  <p>
                    нарушающих предусмотренные законодательством права третьих
                    лиц или неопределённого круга лиц (в том числе,
                  </p>
                  <p>
                    но не ограничиваясь, заимствованные без получения согласия
                    правообладателя материалы, в том числе фотографии,
                  </p>
                  <p>тексты и др.).</p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <b>
                      VII. Лицензионное вознаграждение за использование базы
                      данных и программы
                    </b>
                  </p>
                  <p>
                    &nbsp; 1. Правообладатель предоставляет пользователю за
                    вознаграждение право использования базой данных и
                    программой. Оплата вознаграждения правообладателю
                    производится пользователем в порядке предоплаты.
                  </p>
                  <p>
                    &nbsp; &nbsp; 2. Право использования базой данных и
                    программой предоставляется правообладателем при условии
                  </p>
                  <p>
                    регистрации пользователя на сайте teleportos.ru и получения
                    вознаграждения.
                  </p>
                  <p>
                    &nbsp; &nbsp; 3. Пользователь имеет возможность использовать
                    при авторизации на сайте посредством СМС за отдельную плату.
                  </p>
                  <p>
                    &nbsp; &nbsp; 4. Вознаграждение за предоставление права
                    использования базой данных и программой не облагается НДС
                  </p>
                  <p>на основании п.п. 26 п. 2 ст. 149 НК РФ.</p>
                  <p>
                    &nbsp; &nbsp; 5. Оплата лицензионного вознаграждения
                    производится пользователем в российских рублях в безналичном
                    порядке,
                  </p>
                  <p>
                    либо путём зачисления денежных средств на счёт
                    правообладателя, либо другими способами, доступными в
                    интерфейсе программы.
                  </p>
                  <p>
                    &nbsp; &nbsp; 6. Зачисленные денежные средства отображаются
                    в интерфейсе программы на счёте учётной записи и учитываются
                  </p>
                  <p>
                    для целей исчисления срока действия лицензии Оплата
                    осуществляется в размерах, соответствующих периодам
                    пользования в соответствии с выбранным тарифным планом.
                    Частичная оплата не учитывается.
                  </p>
                  <p>
                    &nbsp; &nbsp; 7. В случае окончания оплаченного срока
                    действия лицензии, доступ к базе данных и программе может
                    быть заблокирован или ограничен.
                  </p>
                  <p>
                    &nbsp; &nbsp; 8. Пользователь производит акцепт предложения
                    о покупке лицензии путём оплаты авансового платежа в размере
                  </p>
                  <p>
                    100% стоимости лицензионного вознаграждения, указанного в
                    прайс-листе в соответствии с выбранным пользователем
                    тарифом.
                  </p>
                  <p>
                    &nbsp; &nbsp; 9. Обязанность пользователя оплатить
                    лицензионное вознаграждение считается исполненной с момента
                  </p>
                  <p>
                    поступления денежных средств на расчётный счёт
                    правообладателя.
                  </p>
                  <p>
                    &nbsp; &nbsp;10. Настоящим стороны договорились, что, если
                    прекращение лицензии произошло ранее истечения срока
                    использования базы данных и программы, в течение которого
                    использование базы данных и программы было оплачено, сумма
                    произведённой пользователем предоплаты лицензионного
                    вознаграждения не подлежит возврату.
                  </p>
                  <p>
                    &nbsp; 11. В случаях, предусмотренных действующим
                    законодательством, при оплате лицензии посредством сети
                    «Интернет» через интерфейс программы, кассовый чек
                    направляется на адрес электронной почты, указанный
                    пользователем
                  </p>
                  <p>
                    при размещении заказы либо при регистрации пользователя.
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <b>VIII. Условия об интеллектуальных правах</b>
                  </p>
                  <p>
                    &nbsp; &nbsp; 1. База данных и программа являются объектами
                    исключительных прав.
                  </p>
                  <p>
                    &nbsp; &nbsp; 2. Кроме случаев, прямо установленных
                    настоящей лицензией, а также действующим законодательством
                  </p>
                  <p>
                    Российской Федерации, база данных и/или программа не могут
                    быть скопированы (воспроизведены), переработаны,
                    распространены, опубликованы, скачаны, переданы, проданы или
                    иным способом использованы целиком
                  </p>
                  <p>
                    или по частям без предварительного разрешения
                    правообладателя.
                  </p>
                  <p>
                    &nbsp; &nbsp; 3. Любое использование базы данных и
                    программы, кроме разрешённого в настоящей лицензии
                  </p>
                  <p>
                    или в случае явно выраженного согласия правообладателя на
                    такое использование, без предварительного письменного
                    разрешения правообладателя, категорически запрещено.
                  </p>
                  <p>
                    &nbsp; &nbsp; 4. Если иное явным образом не установлено в
                    настоящей лицензии, ничто в настоящей лицензии
                  </p>
                  <p>
                    не может быть рассмотрено как передача пользователю
                    исключительных прав на базы данных и программу.
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <b>IX. Гарантии</b>
                  </p>
                  <p>
                    &nbsp; &nbsp; 1. База данных и программа предоставляются на
                    условиях «как есть» (as is). Правообладатель не
                    предоставляет
                  </p>
                  <p>
                    никаких гарантий в отношении безошибочной и бесперебойной
                    работы базы данных и/или программы или отдельных
                  </p>
                  <p>
                    их компонентов и/или функций, соответствия базы данных и/или
                    программы конкретным целям и ожиданиям пользователя, не
                    гарантирует достоверность, точность, полноту и
                    своевременность базы данных, программы и/или заказов,
                  </p>
                  <p>
                    а также не предоставляет никаких иных гарантий, прямо не
                    указанных в настоящей лицензии.
                  </p>
                  <p>&nbsp; &nbsp; 2. Пользователь гарантирует, что:</p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; а) он полностью ознакомился с
                    условиями настоящей лицензии, понимает их значение и
                    последствия своих действий
                  </p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; по &nbsp; &nbsp;заключению
                    настоящей лицензии;
                  </p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; б) он обладает всеми правами и
                    полномочиями, необходимыми для заключения и исполнения
                    настоящей лицензии;
                  </p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; в) размещаемые им в базе данных
                    заказы не нарушают и не влекут за собой нарушение
                    действующего
                  </p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;законодательства &nbsp;
                    &nbsp;РФ и/или прав третьих лиц.
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <b>X. Территория и срок действия лицензии</b>
                  </p>
                  <p>
                    &nbsp; &nbsp; 1. Пользователь вправе использовать базу
                    данных и программу способами, описанными в настоящей
                    лицензии
                  </p>
                  <p>
                    и в интерфейсе программы, на всей территории Российской
                    Федерации.
                  </p>
                  <p>
                    &nbsp; &nbsp; 2. Настоящая лицензия действует с момента
                    принятия её условий пользователем до её прекращения в
                    соответствии
                  </p>
                  <p>с условиями лицензии.</p>
                  <p>&nbsp; &nbsp; 3. Лицензия может быть прекращена:</p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; а) по инициативе любой из сторон
                    в случае нарушения другой стороной условий лицензии с
                    письменным
                  </p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; уведомлением &nbsp; другой
                    стороны за 30 (тридцать) календарных дней до даты
                    прекращения.
                  </p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; б) по инициативе правообладателя
                    в одностороннем внесудебном порядке в случаях грубого
                    нарушения
                  </p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; пользователем &nbsp;
                    &nbsp;обязательств и/или гарантий, принятых в соответствии с
                    лицензией путём уведомления пользователя
                  </p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; по электронной почте за 1 (один)
                    календарный день до даты прекращения.
                  </p>
                  <p>
                    &nbsp; &nbsp; 4. В целях обеспечения прав потребителей, в
                    случае прекращения лицензии правообладатель вправе
                  </p>
                  <p>
                    уведомить заказчиков, с которым заключены договоры об
                    оказании транспортных услуг о прекращении лицензии.
                  </p>
                  <p>
                    &nbsp; &nbsp;5. Внесённые пользователем данные сохраняются в
                    системе после прекращения действия лицензии в течение 6
                    месяцев на случай продления лицензии и уничтожаются не
                    позднее одного года после прекращения лицензии.
                  </p>
                  <p>
                    <br />
                  </p>
                  <p>
                    <b>XI. Ответственность</b>
                  </p>
                  <p>
                    &nbsp; &nbsp; 1. Правообладатель не несёт ответственности за
                    какие-либо прямые или косвенные убытки от использования
                  </p>
                  <p>
                    или невозможности использования программы или базы данных
                    и/или ущерб, причинённый пользователю и/или третьим сторонам
                    в результате какого-либо использования, неиспользования или
                    невозможности использования программы
                  </p>
                  <p>
                    или базы данных, отдельных её компо­нен­тов и/или функций, в
                    том числе из-за возможных ошибок или сбоев в работе
                    программы, за исключением случаев, прямо предусмотренных
                    законодательством.
                  </p>
                  <p>
                    &nbsp; &nbsp; 2. Пользователь несёт ответственность в полном
                    объёме за:
                  </p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; а) соблюдение всех требований
                    законодательства, в том числе законодательства об
                    интеллектуальной собственности,
                  </p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; о конкуренции, но не
                    ограничиваясь перечисленным, в отношении содержания и формы
                    заказов,
                  </p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; иные действия, осуществляемые им
                    в рамках лицензии;
                  </p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; б) достоверность сведений,
                    указанных им при регистрации в качестве пользователя, а
                    также иных предоставляемых
                  </p>
                  <p>
                    &nbsp; &nbsp; &nbsp; &nbsp; им све­де­ний и за достоверность
                    гарантий и заверений пользователя, содержащихся в настоящей
                    лицензии.
                  </p>
                  <p>
                    &nbsp; &nbsp; 3. При использовании базы данных для
                    формирования и исполнения заказов пользователи обязуются
                    получить согласие
                  </p>
                  <p>у субъектов персональных данных на их обработку.</p>
                  <p>
                    &nbsp; &nbsp; 4. Пользователь обязуется своими силами и за
                    свой счёт разрешать споры и урегулировать претензии третьих
                    лиц
                  </p>
                  <p>
                    в отношении приёма или исполнения заказов, возместить убытки
                    (включая судебные расходы), причинённые правообладателю в
                    связи с предъявленными к нему претензиями и исками,
                    основанием предъявления которых явилось принятие
                    пользователем заявок и размещение заказов в базе данных. В
                    случае если содержание, форма или порядок исполнения заказов
                    явилось основанием для предъявления к правообладателю
                    предписаний по уплате штрафных санкций со стороны
                    государственных органов, пользователь обязуется
                    незамедлительно по требованию правообладателя предоставить
                    ему всю запрашиваемую информацию, содействовать
                    правообладателю в урегулировании предписаний,
                  </p>
                  <p>
                    а также возместить все убытки (включая расходы по уплате
                    штрафов), причинённые правообладателю вследствие
                    предъявления ему предписаний в результате размещения заказов
                    пользователя в базе данных.
                  </p>
                  <p>
                    &nbsp; &nbsp; 5. Все претензии, связанные с
                    использованием/невозможностью использования базы данных и
                    программы,
                  </p>
                  <p>
                    а также возможным нарушением базой данных и программой
                    законодательства и/или прав третьих лиц, должны направляться
                    через форму обратной связи.
                  </p>
                  <p>
                    &nbsp; &nbsp; 6. Пользователь самостоятельно и в полном
                    объёме несёт предусмотренную законодательством
                    ответственность как лицо, осуществлявшее оказание
                    транспортных услуг с использованием, предоставленных
                    программой и базой данных возможностей, и гарантирует
                    оказание услуг всем требованиям действующего
                    законодательства.
                  </p>
                  <p>
                    &nbsp; &nbsp; 7. Все споры по настоящему договору
                    рассматриваются в Арбитражном суде Омской области.
                  </p>
                  <p>
                    <b>XII. Реквизиты правообладателя</b>
                  </p>
                  <p>&nbsp; &nbsp; Наименование: ООО "СИРЕНА БАС"</p>
                  <p>
                    &nbsp; &nbsp; ОГРН 1147746073980 ИНН/КПП
                    7727825776/772701001
                  </p>
                  <p>
                    &nbsp; &nbsp; Адрес в пределах места нахождения: Российская
                    Федерация, 121170, Россия, г Москва, ул Неверовского, д 9
                  </p>
                  <p>
                    &nbsp; &nbsp; Дата публикации лицензионного соглашения: 22
                    января 2019 г.
                  </p>
                </div>
              </div>
            </Col>
            <Col span={6}>
              <Affix
                offsetTop={18}
                target={() => document.getElementById('mainSheet')}
              >
                <div className="sidebarContainer">
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={() => this.props.handleFormSubmit()}
                  >
                    Принять
                  </Button>
                  <Button
                    type="primary"
                    style={{ marginTop: 20 }}
                    ghost
                    onClick={() => this.props.prev()}
                  >
                    Назад
                  </Button>
                </div>
              </Affix>
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

export default LicenseAgreement;
